<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info">
        <div slot="header">
              Grupos
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=franchise/group')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                -->
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Grupo</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                
                <template v-slot:cell(meetingTime)="data">
                    {{  String(data.item.meetingTime).padStart(4,'0').substring(0,2) + ":" + String(data.item.meetingTime).padStart(4,'0').substring(2,4) }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Grupo"
              size="xl">
  
        <b-nav fill>
            <b-nav-item :active="tabInfo=='G'" @click="tabInfo='G'">Grupo</b-nav-item>
            <b-nav-item :active="tabInfo=='U'" @click="tabInfo='U'">Associados do Grupo</b-nav-item>
            <b-nav-item :active="tabInfo=='E'" @click="tabInfo='E'">Eventos</b-nav-item>
        </b-nav>

        <div v-show="tabInfo == 'G'">
          <b-card>
            <group-component :item="selectedItem" :companyId="filters.companyId" @response="handleEdit"></group-component>
          </b-card>
        </div>
        <div v-show="tabInfo == 'U'">
          <b-card>
            <group-user-component :item="selectedItem"></group-user-component>            
          </b-card>
        </div>
        <div v-show="tabInfo == 'E'">
          <b-card>
            <event-date-grid-component :companyId="filters.companyId" :groupId="selectedItem.id"></event-date-grid-component>
          </b-card>
        </div>

      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  import GroupUserComponent from './GroupUserComponent'
  import GroupComponent from './GroupComponent'
  import EventDateGridComponent from '../event/EventDateGridComponent'

  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

  
  //import { table } from 'console'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      GroupComponent,
      GroupUserComponent,
      EventDateGridComponent
    },
    data: () => {
      return {
        tabInfo: 'G',
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],

        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          key: '',
          status: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'name', label: 'Grupo', sortable: true },
          {key: 'weekdayName', label: 'Dia da semana', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          {key: 'meetingTime', label: 'Hora', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
          {key: 'memberCount', label: 'Membros', sortable: true, class: 'text-center', thStyle: { width: "80px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.name, this.filters.key)
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )                  
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/franchise/group",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Grupo',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.name.length <= 2)
            msgError.push("Sigla");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Grupo',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.tabInfo = 'G'
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      handleEdit(obj) {
        this.closeEditModal()
        this.refreshData()
      },
      async refreshData() {
        try {
            var s = this;
            var currentUser = this.$store.state.currentUser
            this.isBusy = true

            await axios.get(
                this.$store.state.ws_url + "/franchise/group?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;
            }
            ).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Grupo',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });

            this.isBusy = false;
        } catch (e) {
            console.log(e)
        }
      },
      changeCompany() {
        this.refreshData();
      },
      openHelp(url) {
          window.open(this.$store.state.config.ws_help + url, '_blank')
        }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId

      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>